/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="97.41"
        height="95.58"
        viewBox="0 0 97.41 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M83.07 3a1.26 1.26 0 0 1 1.25 1.12v34.22a1.25 1.25 0 0 1-2.49.13v-33H71.16v10A1.26 1.26 0 0 1 70 16.8h-.13a1.25 1.25 0 0 1-1.24-1.12V4.26A1.26 1.26 0 0 1 69.79 3h13.28ZM14.36 24a1.26 1.26 0 0 1 1.25 1.12V78H49a1.26 1.26 0 0 1 1.25 1.12v.13a1.24 1.24 0 0 1-1.12 1.24H14.36a1.25 1.25 0 0 1-1.24-1.12V25.22A1.25 1.25 0 0 1 14.36 24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M48 .22a1.23 1.23 0 0 1 1.29-.07l.12.07 47.46 32.49a1.252 1.252 0 0 1-1.3 2.14l-.11-.07-46.75-32L2 34.78a1.26 1.26 0 0 1-1.66-.22l-.08-.11a1.24 1.24 0 0 1 .22-1.65l.1-.09ZM91.09 56.28a1.24 1.24 0 0 1 1.24 1.12v35.93a1.27 1.27 0 0 1-.57 1l-.12.07-2 1a1.22 1.22 0 0 1-1 .06l-.13-.06-3.47-1.73-3.47 1.73a1.2 1.2 0 0 1-1 .06l-.13-.06L77 93.72l-3.47 1.73a1.2 1.2 0 0 1-1 .06l-.14-.06-3.47-1.73-3.46 1.73a1.22 1.22 0 0 1-1 .06l-.13-.06-3.47-1.73-3.47 1.73a1.2 1.2 0 0 1-1 .06l-.14-.06-2-1a1.27 1.27 0 0 1-.68-1V57.53a1.25 1.25 0 0 1 2.49-.13v35.15l.76.39 3.47-1.74a1.31 1.31 0 0 1 1-.06l.13.06 3.47 1.74 3.47-1.74a1.28 1.28 0 0 1 1-.06l.13.06 3.47 1.74 3.47-1.74a1.28 1.28 0 0 1 1-.06l.14.06 3.46 1.74 3.47-1.74a1.31 1.31 0 0 1 1-.06l.13.06 3.47 1.74.76-.39v-35A1.26 1.26 0 0 1 91 56.28Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M91.09 42.92A1.24 1.24 0 0 1 92.33 44v13.53a1.25 1.25 0 0 1-2.49.12V45.42H56.1v12.11a1.25 1.25 0 0 1-1.1 1.24h-.13a1.25 1.25 0 0 1-1.24-1.13V44.17a1.26 1.26 0 0 1 1.12-1.25h36.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M71.52 53.47v2.65l-.41.08-.41.08a6.35 6.35 0 0 0-4.79 3.89 7.83 7.83 0 0 0-.55 3.62 6.21 6.21 0 0 0 3.32 5.29 27.84 27.84 0 0 0 2.79 1.24c1.16.49 2.35.94 3.51 1.44a2.12 2.12 0 0 1 1.32 2.31 2.31 2.31 0 0 1-1.86 2.32 6.62 6.62 0 0 1-1.47.16 3.64 3.64 0 0 1-3.73-2.73c-.11-.32-.19-.66-.29-1L64.51 74a9.27 9.27 0 0 0 2.14 4.4 7.48 7.48 0 0 0 4.88 2.24V84h2.87v-3.41c.57-.11 1.14-.2 1.68-.34a6.63 6.63 0 0 0 4.68-3.8 7.67 7.67 0 0 0 .53-4.63 6.1 6.1 0 0 0-3.1-4.41 35.47 35.47 0 0 0-4.25-1.85c-.87-.35-1.72-.75-2.56-1.16a1.88 1.88 0 0 1-1-1.16A2.6 2.6 0 0 1 72.24 60a3 3 0 0 1 3 .78 5.67 5.67 0 0 1 1.21 1.83l.28.67 4-1.65a8 8 0 0 0-1.46-3 7 7 0 0 0-4.83-2.52v-2.64Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseWithPaperMoneyIcon';

export default Icon;
